import GenericStateTwoBlock from './GenericStateTwoBlock';
import { GenericStateTwoBlockProps, GenericStateTwoBlockValueProps } from './types';

export type { GenericStateTwoBlockProps, GenericStateTwoBlockValueProps };
export default GenericStateTwoBlock;
